import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import { SnackbarProvider } from './shared/snackbar/Snackbar';
import { persistor, store } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import config from './config'
import { SessionProvider } from './shared/SessionExpired/SessionContext';



const setBaseUrl = () => {
  const currentHost = window.location.hostname;

  if (currentHost === 'nucliqlab.3edge.in') {
    window.REACT_APP_BASE_URL = config.development.REACT_APP_BASE_URL;
  } else if (currentHost === 'qa.nucliqmicroterra.com') {
    window.REACT_APP_BASE_URL = config.production.REACT_APP_BASE_URL;
  }
  else {
    window.REACT_APP_BASE_URL = config.production.REACT_APP_BASE_URL;
  }
};

setBaseUrl();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <PersistGate loading={null} persistor={persistor}>
          <SnackbarProvider>
            <SessionProvider>
              <App />
            </SessionProvider>
          </SnackbarProvider>
        </PersistGate>
      </StyledEngineProvider>
    </Provider>
  </BrowserRouter>
);

